var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { hideable: true, loading: _vm.loading } }, [
    _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
      _c("i", { staticClass: "fas fa-sign-out-alt" }),
      _vm._v(" Result\n    ")
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
      _c("pre", { domProps: { innerHTML: _vm._s(_vm.jsonHtml) } }, [
        _vm._v("\n        ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }